<template>
  <div>
  <Menu v-if="RoutePrefix!=='Embeded'"/>
  <span v-if="RoutePrefix==='Embeded'" class="label label-rounded">
    Provided by<a href="https://flightbook.glidernet.org" target="about_blank"> flightbook.glidernet.org</a>
  </span>
  <div class="text-center">
    <h1> {{logbook.airfield.name}} ({{logbook.airfield.code}})&nbsp;<country-flag :country="logbook.airfield.country" size='big' shadow/></h1>
    <div v-if="RoutePrefix!=='Embeded'" class="popover popover-left">
      <button class="btn btn-primary btn-action"><i class="icon icon-bookmark"></i></button>
        <div class="popover-container">
          <div class="card">
            <div class="card-header text-primary text-bold">
              Embed {{logbook.airfield.code}} FlightBook
            </div>
            <div class="card-body">
            <code>
              &lt;iframe width="100%" height="100%" src="https://flightbook.glidernet.org/embeded/{{logbook.airfield.code}}" 
              frameborder="0"&gt;&lt;/iframe&gt;
            </code>
          </div>
        </div>
      </div>
    </div>
    <section v-if="valid_airfield">
      <h3>Alt: {{altconv(logbook.airfield.elevation, opts.feet)}}&nbsp;|&nbsp;
        <div class="popover popover-bottom">
          <img class="c-hand tz" :src="require('@/assets/tz.png')">
          <div class="popover-container">
            <div class="card text06">
              <div class="card-header">
                <div class="card-title text-primary h3">{{replace_tzname(logbook.airfield.time_info.tz_name)}}</div>
                <div class="card-subtitle text-gray">{{logbook.airfield.time_info.tz_offset}}</div>
              </div>
              <div class="card-body">
                  <div class="columns col-gapless">
                    <div class="column col-12"><span class="text-primary">Ephemeride {{logbook.date}}</span></div>
                    <div class="column col-6">Dawn:</div>
                    <div class="column col-6">{{logbook.airfield.time_info.dawn}}</div>
                    <div class="column col-6">Sunrise:</div>
                    <div class="column col-6">{{logbook.airfield.time_info.sunrise}}</div>
                    <div class="column col-6">Noon:</div>
                    <div class="column col-6">{{logbook.airfield.time_info.noon}}</div>
                    <div class="column col-6">Sunset:</div>
                    <div class="column col-6">{{logbook.airfield.time_info.sunset}}</div>
                    <div class="column col-6">Twilight:</div>
                    <div class="column col-6">{{logbook.airfield.time_info.twilight}}</div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;<span class="label label-rounded">{{clock}}</span></h3>
    </section>
    <section v-else>
      <h3 class="text-error">Invalid Airfield</h3>
    </section>
    <h3><button class="btn btn-action" v-on:click="add_days(-1)"><i class="icon icon-arrow-left"></i></button>&nbsp;
    {{logbook.a_day}}&nbsp;{{logbook.date}}
    &nbsp;
    <button v-if="date_over===1" class="btn btn-action" v-on:click="add_days(1)">
      <i class="icon icon-arrow-right"></i>
    </button>
    <button v-if="date_over===0" class="btn btn-success" @click="fleet">Live @ {{this.logbook.code}}</button></h3>
  </div>
  
  <div class="form-group form-inline">
  <label class="form-checkbox">
    <input type="checkbox" v-model="opts.feet" checked=""><i class="form-icon"></i> Imperial Units
  </label>
  </div>
  <div class="form-group">
      <label class="form-switch form-inline">
          <input type="checkbox" v-model="opts.detect" checked=""><i class="form-icon"></i> Tow Detect
      </label>
      <label class="form-switch form-inline">
          <input type="checkbox" v-model="opts.glider_only"><i class="form-icon"></i>Glider Only
      </label>
      <label class="form-switch form-inline">
          <input type="checkbox" v-model="opts.show_cn"><i class="form-icon"></i>CN
      </label>
      <label class="form-switch form-inline">
          <input type="checkbox" v-model="opts.show_id"><i class="form-icon"></i>Device ID
      </label>
      <label class="form-switch form-inline">
          <input type="checkbox" v-model="opts.show_qfu"><i class="form-icon"></i>QFU
      </label>
      <label class="form-switch form-inline">
          <input type="checkbox" v-model="opts.qfe"><i class="form-icon"></i>QFE
      </label>
  </div>
    
  <section v-if="errored">
    <p class="text-error">Error on LogBook Api</p>
  </section>
  <section v-else>
    <div v-if="loading">Loading...</div>
    <table class="table table-striped table-hover">
        <thead>
            <tr>
                <th v-bind:colspan="colspan + opts.show_cn + opts.show_id + opts.show_qfu*2">Flight</th>
                <th v-if="opts.detect" v-bind:colspan="colspan + opts.show_cn + opts.show_id + opts.show_qfu">Associated Tow</th>
            </tr>
            <tr>
                <th v-if="opts.show_id">Device</th>
                <th>Registration</th>
                <th v-if="opts.show_cn">CN</th>
                <th>Aircraft</th>
                <th>
                    Start <button class="btn btn-sm s-circle" 
                    @click="click_sort('start')"
                    :disabled="sort.start"
                    >▼</button>
                </th>
                <th v-if="opts.show_qfu">QFU</th>
                <th>
                    Stop <button class="btn btn-sm s-circle"
                    @click="click_sort('stop')"
                    :disabled="sort.stop"
                    >▼</button>
                </th>
                <th v-if="opts.show_qfu">QFU</th>
                <th>
                    Dur <button class="btn btn-sm s-circle"
                    @click="click_sort('duration')"
                    :disabled="sort.duration"
                    >▲</button>
                </th>
                <th>
                  <section v-if="logbook.warning">
                  <button class="glow" @click="warn_only=!warn_only">SAR</button>
                  </section>
                  <section v-else>
                    SAR
                  </section>
                </th>
                <th v-if="opts.detect && opts.show_id" class="bg-secondary">Device</th>
                <th v-if="opts.detect" class="bg-secondary">Registration</th>
                <th v-if="opts.detect && opts.show_cn" class="bg-secondary">CN</th>
                <th v-if="opts.detect" class="bg-secondary">Aircraft</th>
                <th v-if="opts.detect" class="bg-secondary">Stop</th>
                <th v-if="opts.detect && opts.show_qfu" class="bg-secondary">QFU</th>
                <th v-if="opts.detect && !opts.qfe" class="bg-secondary">Alt(QNH)</th>
                <th v-if="opts.detect && opts.qfe" class="bg-secondary">Height(QFE)</th>
                <th v-if="opts.detect" class="bg-secondary">Duration</th>
            </tr>
        </thead>	
  
        <tbody>
        <tr v-for="(flight, index) in visible" :key="index">
          <td v-if="opts.show_id">
            <span :class="{'label label-error tooltip tooltip-right': flight.privacy}"
            :data-tooltip="flight.device.tooltip_a">
                {{flight.device.priv_addr}}
            </span>
          </td>
          <td>
            <span :class="{'label label-error tooltip tooltip-right': flight.privacy}"
            :data-tooltip="flight.device.tooltip_r">
                {{flight.device.priv_reg}}
            </span>
          </td>
          <td v-if="opts.show_cn">{{nn(flight.device, 'competition')}}</td>
          <td>{{nn(flight.device, 'aircraft')}}</td>
          <td :class="{'td-warning': flight.start_code || flight.start_delta}">
            <div :class="{'label label-warning': flight.start_code || flight.start_delta}">
              <span :class="{'big_approx':flight.start_big_delta, 'tooltip tooltip-right':flight.start_delta}"
              :data-tooltip="tooltip_approx(flight.start_delta, flight.start_big_delta)">
                {{flight.start}}{{flight.start_delta ? ' ⚠' : ''}}
              </span>
              <div v-if="flight.start_code">
                  <a class="c-hand" v-on:click="link_start(flight)">{{flight.start_code}}</a>
              </div>
            </div>
          </td>
          <td v-if="opts.show_qfu">{{disp_qfu(flight.start_q)}}</td>
          <td :class="{'td-warning': flight.stop_code || flight.stop_delta}">
            <div :class="{'label label-warning': flight.stop_code || flight.stop_delta}">
              <span :class="{'big_approx':flight.stop_big_delta, 'tooltip tooltip-right':flight.stop_delta}"
              :data-tooltip="tooltip_approx(flight.stop_delta, flight.stop_big_delta)">
                {{flight.stop}}{{flight.stop_delta ? ' ⚠' : ''}}
              </span>
              <div v-if="flight.stop_code">
                  <a class="c-hand" v-on:click="link_stop(flight)">{{flight.stop_code}}</a>
              </div>
            </div>
          </td>
          <td v-if="opts.show_qfu">{{disp_qfu(flight.stop_q)}}</td>
          <td :class="{'td-warning': (flight.start_delta || flight.stop_delta) && flight.duration}">
            <div v-if="flight.duration" :class="{'label label-warning': flight.start_delta || flight.stop_delta}">
              <span :class="{'big_approx': flight.start_big_delta || flight.stop_big_delta,
              'tooltip tooltip-right':flight.start_delta || flight.stop_delta}"
              :data-tooltip="tooltip_approx_duration(flight.start_delta+flight.stop_delta, (flight.start_big_delta || flight.stop_big_delta))">
                {{flight.duration_hm}}{{(flight.start_delta || flight.stop_delta) ? ' ⚠' : ''}}
              </span>
            </div>
            <span v-if="flight.duration_expected_hm" class="big_approx">{{flight.duration_expected_hm}} ⏳</span>
          </td>
          <td><div>
            <img v-if="!flight.trace" :src=cross(flight.stop) class="cross c-hand"
            @click="sar(flight.device.address)">
            <div v-else>
              <img :src="require('@/assets/trace.png')" class="trace c-hand" @click="trace(flight)">
              <span class="label label-rounded label-success label-igc c-hand" @click="igc(flight)">igc</span>
            </div>
          </div></td>
          <td v-if="opts.detect && opts.show_id" class="bg-secondary">{{nn(flight.tow, 'device.address')}}</td>
          <td v-if="opts.detect" class="bg-secondary">{{nn(flight.tow, 'device.registration')}}</td>
          <td v-if="opts.detect && opts.show_cn" class="bg-secondary">{{nn(flight.tow, 'device.competition')}}</td>
          <td v-if="opts.detect" class="bg-secondary">{{nn(flight.tow, 'device.aircraft')}}</td>
          <td v-if="opts.detect" class="bg-secondary" :class="{'td-warning': nn(flight.tow,'stop_delta')}">
            <div :class="{'label label-warning': nn(flight.tow, 'stop_delta')}">
              <span :class="{'big_approx':nn(flight.tow, 'stop_big_delta'), 'tooltip tooltip-right':nn(flight.tow,'stop_delta')}"
              :data-tooltip="tooltip_approx(nn(flight.tow, 'stop_delta'), nn(flight.tow, 'stop_big_delta'))">
                {{nn(flight.tow, 'stop')}}{{nn(flight.tow,'stop_delta') ? ' ⚠' : ''}}
              </span>
            </div>
          </td>
          <td v-if="opts.detect && opts.show_qfu" class="bg-secondary">{{disp_qfu(nn(flight.tow, 'stop_q'))}}</td>
          <td v-if="opts.detect && !opts.qfe" class="bg-secondary">{{altconv(nn(flight.tow, 'max_alt'), opts.feet)}}</td>
          <td v-if="opts.detect && opts.qfe" class="bg-secondary">{{altconv(nn(flight.tow, 'max_height'), opts.feet)}}</td>
          <td v-if="opts.detect" class="bg-secondary" :class="{'td-warning': nn(flight.tow,'stop_delta') && nn(flight.tow, 'duration_hms')}">
            <div v-if="nn(flight.tow,'duration_hms')" :class="{'label label-warning': nn(flight.tow, 'stop_delta')}">
              <span :class="{'big_approx':nn(flight.tow,'stop_big_delta'), 'tooltip tooltip-left':nn(flight.tow,'stop_delta')}"
              :data-tooltip="tooltip_approx_duration((nn(flight.tow, 'stop_delta')), nn(flight.tow, 'stop_big_delta'))">
                {{nn(flight.tow, 'duration_hms')}}{{nn(flight.tow,'stop_delta') ? ' ⚠' : ''}}
              </span>
            </div>
          </td>
        </tr>
        </tbody>
    </table>
  </section>
  </div>
</template>

<script>
import axios from 'axios';
import { create_logbook, nullable, altconv, update_expected } from '@/utils/external.js'
import { format, add, compareAsc} from 'date-fns'
import Menu from '@/components/menu.vue'
import CountryFlag from 'vue-country-flag'
const api_url = process.env.VUE_APP_APIURL
var logbook_ = {airfield: {time_info: {}, country:""}, flights: [], devices:[]}
var opts_ = {detect: true, glider_only: false, show_cn: false, show_id: false, show_qfu: false, qfe: false, feet: false}
let interval = ""
let zeroPadding = (num, digit) => {
    let zero = '';
    for(var i = 0; i < digit; i++) {
        zero += '0';
    }
    return (zero + num).slice(-digit);
}


export default {
  name: 'CompLogBook',
  components: { Menu, CountryFlag}, 
  data:  function() {
    return{
      logbook: logbook_,
      opts: opts_,
      sort: {start: true, stop:false, duration:false},
      colspan: 6,
      loading: true,
      errored: false,
      valid_airfield: true,
      warn_only: false,
      tooltip_u_r: "This aircraft is unregistered.\nRegister in OGN database for showing full info",
      tooltip_u_a: "This device ID is randomly generated.\nRegister in OGN database for showing ID",
      tooltip_h_r: "This aircraft is voluntarily hidden.\nIdentified option is deactivated in OGN database",
      tooltip_h_a: "This device ID is randomly generated.\nIdentified option is deactivated in OGN database",
      clock: "",
      }
    },
  methods: {
    nn: nullable,
    altconv: altconv,
    disp_qfu (qfu){
    if (qfu!=null) return String(qfu).padStart(2, '0')
    },
    link_start (flight){
        let route=`${this.RoutePrefix}2`
        this.$router.push({name: route, params: {code:flight.start_code, date: this.logbook.date}})
        this.logbook.flights = this.logbook.devices= []
        this.loading = true
        this.errored = false
        this.warn_only = false
        this.xhr(flight.start_code, this.logbook.date)
    },
    link_stop (flight){
        let route=`${this.RoutePrefix}2`
        this.$router.push({name: route, params: {code:flight.stop_code, date: this.logbook.date}})
        this.logbook.flights = this.logbook.devices= []
        this.loading = true
        this.errored = false
        this.warn_only = false
        this.xhr(flight.stop_code, this.logbook.date)
    },
    xhr (code, date) {
        axios
      .get([api_url, 'api/logbook',code, date].join('/'))
      .then(response => {
        this.logbook = create_logbook(response.data)
        if (this.logbook.airfield.name==null) this.valid_airfield = false
        this.time_update(false)
        })
      .catch(error =>{
        console.log("Error while consuming Api:" + error)
        this.errored = true
      })
      .finally(() => this.loading = false)
    },
    
    add_days (nb) {
      let current_date = new Date(this.logbook.date + 'T00:00:00')
      let new_date = format(add(current_date, {days: nb}), 'yyyy-MM-dd')
      let route = `${this.RoutePrefix}2`
      this.$router.push({name: route, params: {code: this.logbook.airfield.code, date: new_date}})
      this.logbook.date = new_date
      this.logbook.flights = this.logbook.devices= []
      this.loading = true
      this.errored = false
      this.warn_only = false
      this.xhr(this.logbook.airfield.code, new_date)
    },
    sar (id) {
      this.$router.push(['/sar', id].join('/'))
    },
    fleet () {
      this.$router.push(['/map', this.logbook.airfield.code].join('/'))
    },
    cross (stop) {
       if (stop===null) return require("@/assets/cross_red.png")
       else return require("@/assets/cross_green.png")
    },
    trace (flight){
        this.$store.commit('save_flight', flight)
        this.$store.commit('save_tz', [this.logbook.airfield.time_info.tz_name, this.logbook.airfield.time_info.tz_offset])
        this.$router.push('/trace')
    },
    igc (flight){
      let address = flight.device.address
      // take 30s before and after start detection for path display (in case of exact time) or +/- delta min (in case of approx time)
      let start = flight.start_tsp - (flight.start_delta!==undefined ? flight.start_delta*60 : 30)
      let stop = flight.stop_tsp + (flight.stop_delta!==undefined ? flight.stop_delta*60 : 30)
      let registration_ = flight.device.registration
      let igc_filename = `${this.logbook.date}_`
      if (registration_) igc_filename += `${registration_}.`
      if ((address.charAt(0) === '~') || (address.charAt(0) === '_'))  igc_filename += `#${address.slice(-5)}.igc`
      else igc_filename += `${address}.igc`
      let axios_params={date: this.logbook.date}

      axios
      .get([api_url, 'api/live/igc',address, start, stop].join('/'), {params: axios_params})
      .then(response => {
        const blob = new Blob([response.data], { type: 'text/plain' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = igc_filename
        link.click()
        URL.revokeObjectURL(link.href)
        }).catch(console.error)
    },
    click_sort(evt){
      for (const property in this.sort){
        if (property===evt) this.sort[property] = true
        else this.sort[property] = false
      }
    },
    time_update(expected_update){
      let d = new Date(new Date().toLocaleString('en-US', { timeZone: this.logbook.airfield.time_info.tz_name}));
      this.clock = `${zeroPadding(d.getHours(), 2)}:${zeroPadding(d.getMinutes(), 2)}`
      if (expected_update && this.logbook.update_expected) {
      update_expected(this.logbook.flights)
      // console.log("call update_expected")
      }
    },
    tooltip_approx(delta, big){
      let str =!(big) ? `Not exact detection\nDelta: ±${delta} min` : 'Big approximate\nDo not trust'
      return str 
    },
    tooltip_approx_duration(delta, big){
      let str =!(big) ? `Not exact duration\nDelta: ±${delta} min` : 'Big approximate\nDo not trust' 
      return str
    },
    replace_tzname(tzname){
      if (tzname === undefined) return
      return tzname.replace("America/Argentina", "Argentina")
    }
  },

  computed: {
    RoutePrefix() {
        return this.$route.name.slice(0,7);
    },
    date_over() { 
      if (this.logbook.airfield.time_info === null) return -1
      let zone_date = new Date(new Date().toLocaleString('en-US', { timeZone: this.logbook.airfield.time_info.tz_name}))
      let zone_date_fmt = new Date(format(zone_date, 'yyyy-MM-dd'))
      let logbook_date = new Date(this.logbook.date)
      return compareAsc(zone_date_fmt , logbook_date)
      },
    visible() {
      let visible = this.logbook.flights.filter(flight =>{
        let cond = true && (!flight.towing || !this.opts.detect)
        cond &= (flight.glider || !this.opts.glider_only)
        cond &= ((flight.warning && this.warn_only) || !this.warn_only)
        if (cond) {
          if (flight.device.address.charAt(0) === '~') {
            flight.privacy=true;
            flight.device.priv_reg="UNREG"
            flight.device.tooltip_r = this.tooltip_u_r
            flight.device.tooltip_a = this.tooltip_u_a
            flight.device.priv_addr = '#' + flight.device.address.slice(-5)
            }
          else if (flight.device.address.charAt(0) === '_') {
            flight.privacy=true;
            flight.device.priv_reg="HIDDEN"
            flight.device.tooltip_r = this.tooltip_h_r
            flight.device.tooltip_a = this.tooltip_h_a
            flight.device.priv_addr = '#' + flight.device.address.slice(-5)
            }
          else {
            flight.device.priv_reg= flight.device.registration
            flight.device.priv_addr = flight.device.address
          }
          return flight
        }
      })
      if (this.sort.stop){
        visible.sort((a,b) =>{
          if (a.stop < b.stop) return -1
          else if (a.stop == b.stop) return 0
          else return 1
          })
        }
      if (this.sort.duration){
        visible.sort((a,b) =>{
          if (a.duration  + (a.duration_expected || 0) < b.duration + (b.duration_expected || 0)) return 1
          else if (a.duration + (a.duration_expected || 0) == b.duration + (b.duration_expected || 0)) return 0
          else return -1
        })
      }
      return visible
    }
  },
  

  mounted () {
    this.xhr(this.$route.params.code, this.$route.params.date)
    interval = setInterval(function (){this.time_update(true)}.bind(this), 10000)
    this.$options.sockets.onmessage = (msg) => {
         // auto update on ws event. Only for airfield code and for today date
         if (this.date_over == 0){
          const jmsg = JSON.parse(msg.data)
          if (jmsg.type === 1){
            if (this.logbook.airfield.code == jmsg.data.code){
                console.log("update logbook")
                this.xhr(jmsg.data.code, null)
            }
          }
         }
       }
    
    // don't use localstorage on embeded iframe
    if (this.RoutePrefix ==="Embeded") {
      if ('go' in this.$route.query) this.opts.glider_only = true
      if ('cn' in this.$route.query) this.opts.show_cn = true
      if ('id' in this.$route.query) this.opts.show_id = true
      if ('qfu' in this.$route.query) this.opts.show_qfu = true
      if ('qfe' in this.$route.query) this.opts.qfe = true
      if ('iu' in this.$route.query) this.opts.feet = true
      return
    }
    if (localStorage.getItem('opts')) {
        try {
            let opts = JSON.parse(localStorage.getItem('opts'));
            this.opts = Object.assign({}, opts)
        } catch(e) {
            console.log('Options storage failed:', e)
            localStorage.removeItem('opts');
        }
    }
  },

  beforeDestroy () {
    clearInterval(interval)
    this.$store.commit('save', {
      airfield: this.logbook.airfield, date: this.logbook.date,
      })
  },

  watch: {
    opts:{
          deep: true,
          handler (newopts) {
            // don't use localstorage on embeded iframe
            if (this.RoutePrefix ==="Embeded") return
            const parsed = JSON.stringify(newopts)
            localStorage.setItem('opts', parsed)
            this.$store.commit('save_imp', this.opts.feet)
          }
        },
  }
}
</script>

<style scoped>
@import "~spectre.css/dist/spectre.css";
@import "~spectre.css/dist/spectre-exp.css";
@import "~spectre.css/dist/spectre-icons.css";

.tz{
  vertical-align: middle;
  max-width: 100%;
  height: auto;
}

.td-warning{
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
}

.big_approx{
  color: red
}

.popover-left {
    display: inline-block;
    position: absolute;
    right: 10px;
    top: 40px;
}

@media only screen and (max-width: 1023px) {
    .popover-left {
        display: none;
    }
}

.popover-bottom {
  text-align: left;
}
.text06{
  font-size: .6em;
}

code {
 word-break: break-all;
 text-align: left;
 float: left;
 color: #F60;
}

.label{
border-radius: .3rem;
}

.cross {
	-webkit-transition: .3s ease-in-out;
	transition: .3s ease-in-out;
}

.cross:hover {
	-webkit-transform: scale(1.3);
	transform: scale(1.3);
  transform: rotate(45deg);
}

.trace {
border: 1px solid gray;
vertical-align:bottom;
}

.label.label-success.label-igc{
  background-color: rgb(98, 110, 165);
  margin-left: 0.4rem;
}

@media (max-width: 1023px) {                  
   .label-igc {
      display: none;
   }
}

.glow {
  background-color:#B20000;
  transform: translateZ(0); /*try do decrease CPU usage with forcing GPU trick if not working use a gif :(*/
  border-radius: 10px;
  border: none;
  outline:none;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: Arial;
  font-size: 20px;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  animation: glowing 1500ms 5;
}

@keyframes glowing {
  0% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
  50% { background-color: #FF0000; box-shadow: 0 0 40px #FF0000; }
  100% { background-color: #B20000; box-shadow: 0 0 3px #B20000; }
}
.flag {
  vertical-align: middle;
}

</style>
